import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@components/ui/dropdown-menu";
import { CheckCircle2Icon, MailIcon, UserPlus2Icon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";

export function UserActions({ orgUuid }: { orgUuid: string }) {
  return (
    <>
      <DropdownMenuItem
        render={<Link to={generatePath(ROUTES.SETTINGS_ORGID, { orgUuid })} />}
      >
        <CheckCircle2Icon />
        <Trans>Abonnemangsinformation</Trans>
      </DropdownMenuItem>

      <DropdownMenuSeparator />

      <DropdownMenuItem
        render={
          <Link
            to={generatePath(ROUTES.SETTINGS_TEAM_INVITE_USER_ORGID, {
              orgUuid,
            })}
          />
        }
      >
        <UserPlus2Icon />
        <Trans>Bjud in kollegor</Trans>
      </DropdownMenuItem>

      <DropdownMenuItem
        render={
          <Link to={generatePath(ROUTES.SETTINGS_EMAIL_ORGID, { orgUuid })} />
        }
      >
        <MailIcon />
        <Trans>Notisinställningar</Trans>
      </DropdownMenuItem>
    </>
  );
}
